import {
  getFloat,
  getObject,
} from "@surya-digital/leo-ts-types";
import { Count, CountDTO } from "./count";

export interface CommonResultBreakdownDetailsDTO {
  percentage: number;
  count: CountDTO;
}

export class CommonResultBreakdownDetails {
  readonly isCommonResultBreakdownDetailsCommonResultBreakdownDetails: boolean = true;

  readonly percentage: number;
  readonly count: Count;

  static readonly constraints = {
    "percentage": {
      "minValue": 0,
      "maxValue": 100,
    },
  }

  constructor(
  percentage: number, 
  count: Count
  ) {
    CommonResultBreakdownDetails.validatePercentage(percentage);
    this.percentage = percentage;
    this.count = count;
  }

  static fromDTO(dto: CommonResultBreakdownDetailsDTO): CommonResultBreakdownDetails {
    const percentage = getFloat(dto, "percentage", InvalidCommonResultBreakdownDetailsPercentageError);
    const count = Count.fromDTO(getObject(dto, "count", InvalidCommonResultBreakdownDetailsCountError));
    return new CommonResultBreakdownDetails(
      percentage,
      count
    );
  }

  toDTO(): CommonResultBreakdownDetailsDTO {
    const dto: CommonResultBreakdownDetailsDTO = {
        percentage: this.percentage,
        count: this.count.toDTO()
    };
    return dto;
  }
  private static validatePercentage = (percentage: number): void => {
    if(percentage < 0) {
      throw new InvalidCommonResultBreakdownDetailsPercentageMinValueError(
        0,
        `Attribute percentage has value ${percentage}. Min value is 0.`
      );
    }
    if(percentage > 100) {
      throw new InvalidCommonResultBreakdownDetailsPercentageMaxValueError(
        100,
        `Attribute percentage has value ${percentage}. Max value is 100.`
      );
    }
  }
  
}

CommonResultBreakdownDetails.prototype.toString = function toString(): string {
  return `CommonResultBreakdownDetails(percentage='${this.percentage}',count='${this.count}')`;
};

export class InvalidCommonResultBreakdownDetailsError extends Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidCommonResultBreakdownDetailsError";
  }
}
export class InvalidCommonResultBreakdownDetailsPercentageError extends InvalidCommonResultBreakdownDetailsError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidCommonResultBreakdownDetailsPercentageError";
  }
}

export class InvalidCommonResultBreakdownDetailsPercentageMaxValueError extends InvalidCommonResultBreakdownDetailsPercentageError {
  readonly maxValue: number;
  constructor(maxValue: number, message?: string) {
    super(message);
    this.maxValue = maxValue;
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidCommonResultBreakdownDetailsPercentageMaxValueError";
  }
}

export class InvalidCommonResultBreakdownDetailsPercentageMinValueError extends InvalidCommonResultBreakdownDetailsPercentageError {
  readonly minValue: number;
  constructor(minValue: number, message?: string) {
    super(message);
    this.minValue = minValue;
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidCommonResultBreakdownDetailsPercentageMinValueError";
  }
}

export class InvalidCommonResultBreakdownDetailsCountError extends InvalidCommonResultBreakdownDetailsError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidCommonResultBreakdownDetailsCountError";
  }
}
